import React from "react";

const Rayon = React.forwardRef(
  (
    {
      width = "460",
      height = "512",
      viewBox = "0 0 460 512",
      fill = "none",
      onClick = () => {},
      className,
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className, onClick }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M451.731 363.42L367.687 316.25L451.731 269.08C461.934 263.353 461.922 248.639 451.731 242.919L367.691 195.747L451.73 148.58C461.933 142.853 461.921 128.139 451.73 122.419L237.031 1.92C232.47 -0.64 226.908 -0.64 222.347 1.92L7.64838 122.42C-2.55562 128.148 -2.54062 142.862 7.64838 148.581L91.6914 195.75L7.64738 242.919C-2.55662 248.647 -2.54162 263.361 7.64738 269.08L91.6914 316.25L7.64738 363.42C-2.55662 369.148 -2.54162 383.862 7.64738 389.581L222.347 510.081C226.906 512.64 232.47 512.641 237.031 510.081L451.731 389.581C461.935 383.853 461.92 369.139 451.731 363.42ZM229.689 32.201L413.742 135.5L229.689 238.799L45.6374 135.5L229.689 32.201ZM122.34 212.951L222.348 269.08C226.907 271.639 232.471 271.64 237.032 269.08L337.045 212.948L413.744 255.999L229.689 359.299L45.6374 256L122.34 212.951ZM229.689 479.799L45.6364 376.5L122.339 333.451L222.347 389.58C226.906 392.139 232.47 392.14 237.031 389.58L337.039 333.451L413.742 376.5L229.689 479.799Z"
          fill="black"
        />
        <path
          d="M229.689 324.775C237.974 324.775 244.689 318.059 244.689 309.775C244.689 301.491 237.974 294.775 229.689 294.775C221.405 294.775 214.689 301.491 214.689 309.775C214.689 318.059 221.405 324.775 229.689 324.775Z"
          fill="black"
        />
        <path
          d="M174.76 296.033C183.045 296.033 189.76 289.317 189.76 281.033C189.76 272.749 183.045 266.033 174.76 266.033C166.476 266.033 159.76 272.749 159.76 281.033C159.76 289.317 166.476 296.033 174.76 296.033Z"
          fill="black"
        />
        <path
          d="M119.833 268.554C128.117 268.554 134.833 261.838 134.833 253.554C134.833 245.27 128.117 238.554 119.833 238.554C111.548 238.554 104.833 245.27 104.833 253.554C104.833 261.838 111.548 268.554 119.833 268.554Z"
          fill="black"
        />
        <path
          d="M284.618 296.033C292.903 296.033 299.618 289.317 299.618 281.033C299.618 272.749 292.903 266.033 284.618 266.033C276.334 266.033 269.618 272.749 269.618 281.033C269.618 289.317 276.334 296.033 284.618 296.033Z"
          fill="black"
        />
        <path
          d="M339.546 268.554C347.831 268.554 354.546 261.838 354.546 253.554C354.546 245.27 347.831 238.554 339.546 238.554C331.262 238.554 324.546 245.27 324.546 253.554C324.546 261.838 331.262 268.554 339.546 268.554Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Rayon;
